define.alias("shared/models/th-post", "settings/models/th-post");